import { Outlet, useLocation } from 'react-router'
import { Location } from 'history'
import { NestedRoute, Route, SecondLevelRoute } from 'src/routing/routing'
import { ROUTES } from 'src/routing/routes'
import { useEffect, useState } from 'react'
import { PageLayout } from 'src/shared/layout/PageLayout'
import { SecondLevelNavigation, SecondLevelNavigationContainer } from 'src/routing/SecondLevelNavigation'

const resolveActiveRoute = (location: Location): SecondLevelRoute => {
  const nested = ROUTES.CriteriaConfigurationIndex!.nested! as unknown as NestedRoute
  const activeRoute = Object.keys(nested).find(
    (key) =>
      location.pathname.endsWith(nested[key].path) ||
      (ROUTES.CriteriaConfigurationIndex.params({}) === location.pathname && nested[key].primary),
  ) as string
  return nested[activeRoute] as SecondLevelRoute
}

export const CriteriaConfigurationIndexPage = () => {
  const location = useLocation()
  const [activeRoute, setActiveRoute] = useState<SecondLevelRoute>(() => {
    return resolveActiveRoute(location)
  })

  useEffect(() => {
    const newActiveRoute = resolveActiveRoute(location)
    setActiveRoute(newActiveRoute)
  }, [location])

  const showNavigation = activeRoute && !activeRoute.hideNavigation

  return (
    <SecondLevelNavigationContainer $showNavigation={showNavigation}>
      {showNavigation && (
        <PageLayout>
          <SecondLevelNavigation
            activeRoute={activeRoute}
            route={ROUTES.CriteriaConfigurationIndex as unknown as Route}
            baseUrl={ROUTES.CriteriaConfigurationIndex.params({})}
          />
        </PageLayout>
      )}
      <Outlet />
    </SecondLevelNavigationContainer>
  )
}
